import {css} from 'lit';
export const styles = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

a {
  color: var(--link-text);
  -webkit-text-decoration: none;
  text-decoration: none;
}

a,
button {
  transition-property: background-color, border-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ease;
}

@media (hover: hover) {
    :is(a,button):not(:disabled) {
      cursor: pointer;
    }
  }

a:focus,
button:focus {
  outline: none;
}

a:focus-visible,
button:focus-visible,
[type='button']:focus-visible,
[type='submit']:focus-visible,
[type='reset']:focus-visible {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: var(--link-focus-outline-offset);
}

@media (hover: hover) {
  a:hover {
    color: var(--link-text-hover);
  }
}

a:active {
  transition: none;
  color: var(--link-text-active);
}

a[href^='tel'],
button[href^='tel'] {
  text-decoration: inherit;
  color: inherit;
}

figure {
  margin: 0;
}

fieldset {
  border-width: 0;
  padding: 0;
  margin: 0;
}

code {
  word-break: break-word;
}

hr {
  margin-top: 16px;
  margin-bottom: 16px;
}

input,
select,
textarea {
  color: var(--body-text);
}

/* Mentions - Append @ character via CSS */
[data-mention-id]::before {
  content: '@';
}
`;
export default styles;
